import { Injectable, inject } from "@angular/core";

import { NavigationService } from "@tylertech/core-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";

@Injectable()
export class UrlActionHandler implements IAggregateActionHandler
{
    private readonly $navigationService = inject(NavigationService);


    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Url;
    }

    execute(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): Promise<boolean>
    {
        if (action.content.substr(0, 1) === "/")
        {
            this.$navigationService.navigateToApp(action.content);
        }
        else
        {
            window.location.href = action.content;
        }
        return Promise.resolve(true);
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
